export default __webpack_public_path__ + "static/media/820.0372ceeb.gif";